// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__Loader__3dgUo","load6":"Spinner__load6__3Ebkm","round":"Spinner__round__2-YqU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 91
// module chunks = 0